import React from 'react';

import cookieStorage from 'helpers/cookieStorage';

const useSaveGclidInCookies = () =>
  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const gclid = queryParams.get('gclid');

    if (gclid) {
      cookieStorage.setItem('gclid', gclid, {
        domain: 'femtasy.com',
        sameSite: 'None',
        secure: true,
      });
    }
  }, []);

export default useSaveGclidInCookies;
